import axios from 'axios'

const state = {
  untaggedCount: 0,
  taggedCount: 0,
  checkedOutUsers: [],
  byProject: [],
  // The counts above initialise to 0/[], which is also what a real
  // empty tenant looks like. Without these three flags the view cannot tell
  // "still waiting" or "the request died" from "the answer is zero", so a
  // slow or failed /api/photos/status/ rendered as confident zeroes.
  // `loaded` is tracked separately from `!loading` because nothing has been
  // loaded before the first fetch resolves, which is exactly that window.
  loading: false,
  loaded: false,
  lastError: null
}

const mutations = {
  setStatus (state, data) {
    state.untaggedCount = data.untagged_count
    state.taggedCount = data.tagged_count
    state.checkedOutUsers = data.checked_out_users
    state.byProject = data.by_project || []
    state.loaded = true
  },
  setStatusLoading (state, loading) { state.loading = loading },
  setStatusError (state, error) { state.lastError = error }
}

const actions = {
  fetchStatus (context) {
    // Clear the old error up front: pairing a stale error with a live spinner
    // tells the user it both failed and is working.
    context.commit('setStatusError', null)
    context.commit('setStatusLoading', true)
    return axios.get('/api/photos/status/')
      .then(response => {
        context.commit('setStatus', response.data)
      })
      .catch(e => { context.commit('setStatusError', e) })
      .finally(() => { context.commit('setStatusLoading', false) })
  },
  unassignUser (context, userId) {
    context.commit('setStatusError', null)
    context.commit('setStatusLoading', true)
    return axios.post('/api/photos/unassign_user/', { user_id: userId })
      .then(response => {
        context.commit('setStatus', response.data)
      })
      // An unassign that quietly failed looked exactly like one that worked
      // until the next page load put the user's images back on screen.
      .catch(e => { context.commit('setStatusError', e) })
      .finally(() => { context.commit('setStatusLoading', false) })
  }
}

export default {
  state,
  mutations,
  actions
}
